export default __webpack_public_path__ + "static/workingguideimage1-ac8ab74c5a721af2cbe163a4eb8c17fd.jpeg";